import type { FeatureFlags } from '@/lib/api';
import type { Area } from '@/lib/perms';

export interface NavItem {
  labelKey: string;
  path: string;
  icon: string;
  badge?: string;
  /** раздел фазы 2: показывается только при включённом фичефлаге */
  flag?: keyof FeatureFlags;
  /** раздел матрицы прав: пункт скрыт, если у роли нет чтения */
  area: Area;
}

export const mainNav: NavItem[] = [
  { labelKey: 'nav.dashboard', path: '/', icon: 'ri-dashboard-3-line', area: 'dashboard' },
  { labelKey: 'nav.partners', path: '/partners', icon: 'ri-store-2-line', area: 'partners' },
  { labelKey: 'nav.import', path: '/import', icon: 'ri-upload-cloud-2-line', area: 'import' },
  { labelKey: 'nav.catalog', path: '/catalog', icon: 'ri-grid-line', area: 'catalog' },
  { labelKey: 'nav.specifications', path: '/specifications', icon: 'ri-file-list-3-line', area: 'specifications' },
  { labelKey: 'nav.purchaseOrders', path: '/purchase-orders', icon: 'ri-shopping-bag-3-line', area: 'purchase_orders' },
];

export const secondaryNav: NavItem[] = [
  { labelKey: 'nav.storefront', path: '/storefront', icon: 'ri-eye-line', flag: 'storefront', area: 'catalog' },
  { labelKey: 'nav.feedback', path: '/feedback', icon: 'ri-lightbulb-flash-line', area: 'feedback' },
  { labelKey: 'nav.settings', path: '/settings', icon: 'ri-settings-4-line', area: 'settings' },
];

export const allNav = [...mainNav, ...secondaryNav];

export const visibleNav = (items: NavItem[], flags: FeatureFlags, can: (area: Area) => boolean = () => true) => items.filter((i) => (!i.flag || flags[i.flag]) && can(i.area));

export const findNavKey = (pathname: string): string => {
  const match = allNav
    .filter((item) => item.path !== '/' && pathname.startsWith(item.path))
    .sort((a, b) => b.path.length - a.path.length)[0];
  if (match) return match.labelKey;
  return 'nav.dashboard';
};
